import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { ImageAction } from '../../molecules/image-action';
import { DropPaste } from '../../plugins/drop-paste';
import { ImagePastePlugin } from '../../plugins/image-paste-plugin';
import { ImagesPlugin, INSERT_IMAGE_COMMAND } from '../../plugins/images-plugin';

type ImageProps = {
  onClick?: () => void;
  src?: string;
  setSrc?: (src: string) => void;
};

export const Image = ({ onClick, src, setSrc }: ImageProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (src) {
      editor.dispatchCommand(INSERT_IMAGE_COMMAND, {
        src,
        altText: '',
      });
      setSrc?.('');
    }
  }, [src, editor, setSrc]);

  return (
    <>
      {onClick && <ImageAction onClick={onClick} aria-label='Add Image' />}
      <ImagesPlugin />
      <ImagePastePlugin />
      <DropPaste />
    </>
  );
};
